import { faSearchDollar } from "@fortawesome/free-solid-svg-icons";
export const ledgerSelection = {
    name: "Ledger Selection",
    minSize: [5, 1],
    icon: faSearchDollar,
    description: "Choose ledger(s)",
    defaultConfig: {
        defaultValue: null,
        key: "Ledger",
    },
    type: "input",
    category: "dashboard",
};
